export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6933.2f4a2ada.jpg";